module.exports = __webpack_public_path__ + "img/success_OLD_4.c0a679d5.gif";